import { useContext } from 'react'

import { GoogleOAuthProvider } from '@react-oauth/google'
import config from 'config'

import notifier from 'tools/Notify'

import GlobalContext from 'reducer/global'

export function SignonProvider({ children }) {
  const [, notifyDispatch] = useContext(GlobalContext)
  return (
    <GoogleOAuthProvider
      clientId={config.auth.google.appId}
      onScriptLoadError={() =>
        notifier.error(
          notifyDispatch,
          'Federated Authentication with Google is blocked by extension'
        )
      }
    >
      {children}
    </GoogleOAuthProvider>
  )
}
